import { Col, Divider, Form, Input, InputNumber, Row, Spin } from 'antd';
import { Content } from 'antd/es/layout/layout';
import Button from 'components/Button';
import React, { useState } from 'react';
import { useForm } from 'antd/es/form/Form';
import formatCurrencyVND from 'utils/formatCurrencyVND';
import AllocateApi from 'apis/Allocate';
import { openNotificationWithIcon } from 'utils/notification';

interface IProps {
  detailCapitalShop: any;
  min: number;
  max: number;
  shop_id: any;
  capital_year: number;
  onCancel: () => void;
  IsCapitalDeclare: boolean;
}

export default function PlantDeclareModalCreate(props: IProps) {
  const {
    min,
    max,
    capital_year,
    shop_id,
    onCancel,
    detailCapitalShop,
    IsCapitalDeclare,
  } = props;

  const [form] = useForm();
  const [isLoading, setIsLoading] = useState(false);
  const validateRules = [
    {
      required: true,
      message: 'Không được để trống',
    },
    {
      message: 'không được nhập số âm',
      validator: (_: any, value: any) => {
        if (value >= 0) {
          return Promise.resolve();
        } else {
          return Promise.reject('Some message here');
        }
      },
    },
  ];
  const limProduct = {
    min:
      0 +
      (Form.useWatch('per_cap_order_min', form) || 0) * 1 +
      (Form.useWatch('per_cap_reorder_min', form) || 0) * 1 +
      (Form.useWatch('per_cap_other_min', form) || 0) * 1,

    max:
      0 +
      (Form.useWatch('per_cap_order_max', form) || 0) * 1 +
      (Form.useWatch('per_cap_reorder_max', form) || 0) * 1 +
      (Form.useWatch('per_cap_other_max', form) || 0) * 1,
  };

  const onFinish = (values: any) => {
    if (values.per_pro_order_min > values.per_pro_order_max) {
      openNotificationWithIcon(
        'error',
        'Tỉ trọng phân bổ Min phải nhỏ hơn hoặc bằng Max'
      );
    } else if (values.per_pro_reorder_min > values.per_pro_reorder_max) {
      openNotificationWithIcon(
        'error',
        'Tỉ trọng phân bổ  Min phải nhỏ hơn hoặc bằng Max'
      );
    } else if (values.per_pro_other_min > values.per_pro_other_max) {
      openNotificationWithIcon(
        'error',
        'Tỉ trọng phân bổ  Min phải nhỏ hơn hoặc bằng Max'
      );
    } else {
      const postValue = {
        capital_year: capital_year,
        cap_order_min: (values.per_cap_order_min * min) / 100,
        cap_order_max: (values.per_cap_order_max * max) / 100,
        per_cap_order_min: values.per_cap_order_min * 1,
        per_cap_order_max: values.per_cap_order_max * 1,
        cap_reorder_min: (values.per_cap_reorder_min * min) / 100,
        cap_reorder_max: (values.per_cap_reorder_max * max) / 100,
        per_cap_reorder_min: values.per_cap_reorder_min * 1,
        per_cap_reorder_max: values.per_cap_reorder_max * 1,
        cap_other_min: (values.per_cap_other_min * min) / 100,
        cap_other_max: (values.per_cap_other_max * max) / 100,
        per_cap_other_min: values.per_cap_other_min * 1,
        per_cap_other_max: values.per_cap_other_max * 1,
        shop_id: shop_id,
        list_capital_pof: [
          {
            pof_type: 'suggest',
            ratio_min: values.per_pro_order_min * 1,
            ratio_max: values.per_pro_order_max * 1,
            description: values.order_description,
          },
          {
            pof_type: 'other',
            ratio_min: values.per_pro_reorder_min * 1,
            ratio_max: values.per_pro_reorder_max * 1,
            description: values.reorder_description,
          },
          {
            pof_type: 'trial',
            ratio_min: values.per_pro_other_min * 1,
            ratio_max: values.per_pro_other_max * 1,
            description: values.other_description,
          },
        ],
      };
      if (
        postValue.per_cap_order_min +
          postValue.per_cap_reorder_min +
          postValue.per_cap_other_min >
          100 ||
        postValue.per_cap_order_max +
          postValue.per_cap_reorder_max +
          postValue.per_cap_other_max >
          100
      ) {
        openNotificationWithIcon(
          'error',
          'Vốn khai báo không được lớn hơn vốn đề xuất'
        );
        // } else if (
        //   postValue.cap_order_min > postValue.cap_order_max ||
        //   postValue.cap_other_min > postValue.cap_other_max ||
        //   postValue.cap_reorder_min > postValue.cap_reorder_max
        // ) {
        //   openNotificationWithIcon(
        //     'error',
        //     'Số tiền Min phải nhỏ hơn hoặc bằng số tiền Max'
        //   );
        // } else if (
        //   postValue.cap_order_min +
        //     postValue.cap_other_min +
        //     postValue.cap_reorder_min !=
        //   min
        // ) {
        //   openNotificationWithIcon(
        //     'error',
        //     'Tổng số tiền Min phân bổ phải bằng số tiền Min đề xuất'
        //   );
        // } else if (
        //   postValue.cap_order_max +
        //     postValue.cap_other_max +
        //     postValue.cap_reorder_max !=
        //   max
        // ) {
        //   openNotificationWithIcon(
        //     'error',
        //     'Tổng số tiền Max phân bổ phải bằng số tiền Max đề xuất'
        //   );
      } else if (
        postValue.list_capital_pof[0].ratio_min +
          postValue.list_capital_pof[1].ratio_min +
          postValue.list_capital_pof[2].ratio_min >
          100 ||
        postValue.list_capital_pof[0].ratio_max +
          postValue.list_capital_pof[1].ratio_max +
          postValue.list_capital_pof[2].ratio_max >
          100
      ) {
        openNotificationWithIcon(
          'error',
          'Tỉ trọng phân bổ sản phẩm khai báo không được lớn hơn vốn khai báo'
        );
      } else if (
        postValue.per_cap_order_max +
          postValue.per_cap_reorder_max +
          postValue.per_cap_other_max !=
        100
      ) {
        openNotificationWithIcon('error', 'Vốn khai báo tối đa chưa đủ 100%');
      } else if (
        postValue.per_cap_order_min +
          postValue.per_cap_reorder_min +
          postValue.per_cap_other_min !=
        100
      ) {
        openNotificationWithIcon(
          'error',
          'Vốn khai báo tối thiểu chưa đủ 100%'
        );
      } else if (
        postValue.list_capital_pof[0].ratio_min +
          postValue.list_capital_pof[1].ratio_min +
          postValue.list_capital_pof[2].ratio_min !=
        100
      ) {
        openNotificationWithIcon(
          'error',
          'Tỉ trọng phân bổ tối thiểu chưa đủ 100%'
        );
      } else if (
        postValue.list_capital_pof[0].ratio_max +
          postValue.list_capital_pof[1].ratio_max +
          postValue.list_capital_pof[2].ratio_max !=
        100
      ) {
        openNotificationWithIcon(
          'error',
          'Tỉ trọng phân bổ tối đa chưa đủ 100%'
        );
      } else if (
        postValue.per_cap_order_min > postValue.per_cap_order_max ||
        postValue.per_cap_reorder_min > postValue.per_cap_reorder_max ||
        postValue.per_cap_other_min > postValue.per_cap_other_max
      ) {
        openNotificationWithIcon(
          'error',
          'Tỷ lệ tối thiểu (Min) không lớn hơn (Max)'
        );
      } else {
        setIsLoading(true);

        AllocateApi.postCapitalProduct(postValue)
          .then((res) => {
            setIsLoading(false);
            openNotificationWithIcon('success', 'Thêm mới thành công');
            onCancel();
          })
          .catch((err) => {
            setIsLoading(false);
            console.log(err.message);
            openNotificationWithIcon(
              'error',
              err.response?.data?.message.toString()
            );
          })
          .finally(() => setIsLoading(false));
      }
    }
  };

  const ValidateMinMax = () => {
    if (
      Form.useWatch('per_cap_order_min', form) >
      Form.useWatch('per_cap_order_max', form)
    ) {
      form.setFields([
        {
          name: 'per_cap_order_min',
          errors: ['min phải nhỏ hơn hoặc bằng max'],
        },
        {
          name: 'per_cap_order_max',
          errors: ['min phải nhỏ hơn hoặc bằng max'],
        },
      ]);
    } else {
      form.setFields([
        {
          name: 'per_cap_order_min',
          errors: [],
        },
        {
          name: 'per_cap_order_max',
          errors: [],
        },
      ]);
    }
    if (
      Form.useWatch('per_cap_reorder_min', form) >
      Form.useWatch('per_cap_reorder_max', form)
    ) {
      form.setFields([
        {
          name: 'per_cap_reorder_min',
          errors: ['min phải nhỏ hơn hoặc bằng max'],
        },
        {
          name: 'per_cap_reorder_max',
          errors: ['min phải nhỏ hơn hoặc bằng max'],
        },
      ]);
    } else {
      form.setFields([
        {
          name: 'per_cap_reorder_min',
          errors: [],
        },
        {
          name: 'per_cap_reorder_max',
          errors: [],
        },
      ]);
    }
    if (
      Form.useWatch('per_cap_other_min', form) >
      Form.useWatch('per_cap_other_max', form)
    ) {
      form.setFields([
        {
          name: 'per_cap_other_min',
          errors: [''],
        },
        {
          name: 'per_cap_others_max',
          errors: ['min phải nhỏ hơn hoặc bằng max'],
        },
      ]);
    } else {
      form.setFields([
        {
          name: 'per_cap_other_min',
          errors: [],
        },
        {
          name: 'per_cap_other_max',
          errors: [],
        },
      ]);
    }

    if (
      Form.useWatch('per_pro_order_min', form) >
      Form.useWatch('per_pro_order_max', form)
    ) {
      form.setFields([
        {
          name: 'per_pro_order_min',
          errors: ['min phải nhỏ hơn hoặc bằng max'],
        },
        {
          name: 'per_pro_order_max',
          errors: ['min phải nhỏ hơn hoặc bằng max'],
        },
      ]);
    } else {
      form.setFields([
        {
          name: 'per_pro_order_min',
          errors: [],
        },
        {
          name: 'per_pro_order_max',
          errors: [],
        },
      ]);
    }
    if (
      Form.useWatch('per_pro_reorder_min', form) >
      Form.useWatch('per_pro_reorder_max', form)
    ) {
      form.setFields([
        {
          name: 'per_pro_reorder_min',
          errors: ['min phải nhỏ hơn hoặc bằng max'],
        },
        {
          name: 'per_pro_reorder_max',
          errors: ['min phải nhỏ hơn hoặc bằng max'],
        },
      ]);
    } else {
      form.setFields([
        {
          name: 'per_pro_reorder_min',
          errors: [],
        },
        {
          name: 'per_pro_reorder_max',
          errors: [],
        },
      ]);
    }
    if (
      Form.useWatch('per_pro_other_min', form) >
      Form.useWatch('per_pro_other_max', form)
    ) {
      form.setFields([
        {
          name: 'per_pro_other_min',
          errors: ['min phải nhỏ hơn hoặc bằng max'],
        },
        {
          name: 'per_pro_other_max',
          errors: ['min phải nhỏ hơn hoặc bằng max'],
        },
      ]);
    } else {
      form.setFields([
        {
          name: 'per_pro_other_min',
          errors: [],
        },
        {
          name: 'per_pro_other_max',
          errors: [],
        },
      ]);
    }
  };
  ValidateMinMax();

  const initialValues =
    IsCapitalDeclare == true
      ? {
          per_cap_order_min: detailCapitalShop?.capital_ratio.per_cap_order_min,
          per_cap_order_max: detailCapitalShop?.capital_ratio.per_cap_order_max,
          per_cap_reorder_min:
            detailCapitalShop?.capital_ratio.per_cap_reorder_min,
          per_cap_reorder_max:
            detailCapitalShop?.capital_ratio.per_cap_reorder_max,
          per_cap_other_min: detailCapitalShop?.capital_ratio.per_cap_other_min,
          per_cap_other_max: detailCapitalShop?.capital_ratio.per_cap_other_max,

          per_pro_order_min: detailCapitalShop?.capital_ratio_pof[0].ratio_min,
          per_pro_order_max: detailCapitalShop?.capital_ratio_pof[0].ratio_max,
          order_description:
            detailCapitalShop?.capital_ratio_pof[0].description,
          per_pro_reorder_min:
            detailCapitalShop?.capital_ratio_pof[1].ratio_min,
          per_pro_reorder_max:
            detailCapitalShop?.capital_ratio_pof[1].ratio_max,
          reorder_description:
            detailCapitalShop?.capital_ratio_pof[1].description,
          per_pro_other_min: detailCapitalShop?.capital_ratio_pof[2].ratio_min,
          per_pro_other_max: detailCapitalShop?.capital_ratio_pof[2].ratio_max,
          other_description:
            detailCapitalShop?.capital_ratio_pof[2].description,
        }
      : {};

  return (
    <Spin spinning={isLoading}>
      <Form
        layout="vertical"
        initialValues={initialValues}
        form={form}
        onFinish={onFinish}
      >
        <Content style={{ borderTop: '1px solid #E1E3E6' }}>
          <Row>
            <p>
              Vốn phân bổ đề xuất :{' '}
              <span style={{ fontWeight: 'bold', fontSize: '16px' }}>
                {formatCurrencyVND(min)} - {formatCurrencyVND(max)}
              </span>
            </p>
          </Row>

          <Divider style={{ borderColor: '#E1E3E6' }} dashed />

          <Row
            gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
            justify="start"
            align="middle"
            style={{
              marginBottom: '5px',
              fontWeight: 'bold',
            }}
          >
            <Col span={3} offset={5}>
              <span>Min</span>
            </Col>
            <Col span={3}>
              <span>Max</span>
            </Col>
          </Row>

          <Row
            gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
            justify="start"
            align="top"
          >
            <Col span={5}>
              {' '}
              <span style={{ fontWeight: 'bold' }}>Vốn hàng hoá</span>
            </Col>
            <Col span={3}>
              <Form.Item name="per_cap_order_min" rules={validateRules}>
                <InputNumber
                  size="small"
                  style={{ width: '100%' }}
                  formatter={(value) => `${value} %`}
                  max={100}
                />
              </Form.Item>
            </Col>
            <Col span={3}>
              <Form.Item name="per_cap_order_max" rules={validateRules}>
                <InputNumber
                  size="small"
                  style={{ width: '100%' }}
                  formatter={(value) => `${value} %`}
                  max={100}
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              Min:{' '}
              {formatCurrencyVND(
                ((Form.useWatch('per_cap_order_min', form) || 0) * min) / 100
              )}
            </Col>

            <Col span={1}>-</Col>
            <Col span={6}>
              Max:{' '}
              {formatCurrencyVND(
                ((Form.useWatch('per_cap_order_max', form) || 0) * max) / 100
              )}
            </Col>
          </Row>

          <Row
            gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
            justify="start"
            align="top"
          >
            <Col span={5}>
              {' '}
              <span style={{ fontWeight: 'bold' }}>Vốn mua lại</span>
            </Col>
            <Col span={3}>
              <Form.Item name="per_cap_reorder_min" rules={validateRules}>
                <InputNumber
                  size="small"
                  style={{ width: '100%' }}
                  formatter={(value) => `${value} %`}
                  max={100}
                />
              </Form.Item>
            </Col>
            <Col span={3}>
              <Form.Item name="per_cap_reorder_max" rules={validateRules}>
                <InputNumber
                  size="small"
                  style={{ width: '100%' }}
                  formatter={(value) => `${value} %`}
                  max={100}
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              Min:{' '}
              {formatCurrencyVND(
                ((Form.useWatch('per_cap_reorder_min', form) || 0) * min) / 100
              )}
            </Col>
            <Col span={1}>-</Col>
            <Col span={6}>
              Max:{' '}
              {formatCurrencyVND(
                ((Form.useWatch('per_cap_reorder_max', form) || 0) * max) / 100
              )}
            </Col>
          </Row>

          <Row
            gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
            justify="start"
            align="top"
          >
            <Col span={5}>
              {' '}
              <span style={{ fontWeight: 'bold' }}>Vốn khác</span>
            </Col>
            <Col span={3}>
              <Form.Item name="per_cap_other_min" rules={validateRules}>
                <InputNumber
                  size="small"
                  style={{ width: '100%' }}
                  formatter={(value) => `${value} %`}
                  max={100}
                />
              </Form.Item>
            </Col>
            <Col span={3}>
              <Form.Item name="per_cap_other_max" rules={validateRules}>
                <InputNumber
                  size="small"
                  style={{ width: '100%' }}
                  formatter={(value) => `${value} %`}
                  max={100}
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              Min:{' '}
              {formatCurrencyVND(
                ((Form.useWatch('per_cap_other_min', form) || 0) * min) / 100
              )}
            </Col>
            <Col span={1}>-</Col>
            <Col span={6}>
              Max:{' '}
              {formatCurrencyVND(
                ((Form.useWatch('per_cap_other_max', form) || 0) * max) / 100
              )}
            </Col>
          </Row>

          <Divider style={{ borderColor: '#E1E3E6' }} dashed />

          <Row
            gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
            justify="start"
            align="top"
            style={{ fontWeight: 'bold', color: '#00538F' }}
          >
            <Col span={3} offset={5}>
              {limProduct.min.toFixed(2)}%
            </Col>
            <Col span={3}>{limProduct.max.toFixed(2)}%</Col>

            <Col span={6}>
              Min: {formatCurrencyVND((limProduct.min * min) / 100)}
            </Col>
            <Col span={1}>-</Col>
            <Col span={6}>
              Max: {formatCurrencyVND((limProduct.max * max) / 100)}
            </Col>
          </Row>

          <Divider style={{ borderColor: '#E1E3E6' }} dashed />

          <strong style={{ fontSize: '16px' }}>
            Tỉ trọng phân bổ sản phẩm
          </strong>

          <Row
            gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
            justify="start"
            align="bottom"
            style={{ marginTop: '15px' }}
          >
            <Col span={5}>
              {' '}
              <span>Hàng hoá khuyến nghị</span>
            </Col>
            <Col span={4}>
              <Form.Item
                label="Tỷ lệ tối thiểu (Min)"
                name="per_pro_order_min"
                rules={validateRules}
              >
                <InputNumber
                  size="small"
                  style={{ width: '100%' }}
                  formatter={(value) => `${value} %`}
                  max={100}
                />
              </Form.Item>
            </Col>
            <Col span={4}>
              <Form.Item
                label="Tỷ lệ tối thiểu (Max)"
                name="per_pro_order_max"
                rules={validateRules}
              >
                <InputNumber
                  size="small"
                  style={{ width: '100%' }}
                  formatter={(value) => `${value} %`}
                  max={100}
                />
              </Form.Item>
            </Col>
            <Col span={5}>
              Min:{' '}
              {formatCurrencyVND(
                ((Form.useWatch('per_pro_order_min', form) || 0) *
                  (Form.useWatch('per_cap_order_min', form) || 0) *
                  min) /
                  10000
              )}
            </Col>

            <Col span={1}>-</Col>
            <Col span={5}>
              Max:{' '}
              {formatCurrencyVND(
                ((Form.useWatch('per_pro_order_max', form) || 0) *
                  (Form.useWatch('per_cap_order_max', form) || 0) *
                  max) /
                  10000
              )}
            </Col>
          </Row>

          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col span={19} offset={5}>
              <Form.Item label="Ghi chú" name="order_description">
                <Input style={{ height: '24px' }} />
              </Form.Item>
            </Col>
          </Row>

          <Row
            gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
            justify="start"
            align="bottom"
            style={{ marginTop: '15px' }}
          >
            <Col span={5}>
              {' '}
              <span>
                Hàng hóa <br /> Hàng ngoài danh mục
              </span>
            </Col>
            <Col span={4}>
              <Form.Item
                label="Tỷ lệ tối thiểu (Min)"
                name="per_pro_reorder_min"
                rules={validateRules}
              >
                <InputNumber
                  size="small"
                  style={{ width: '100%' }}
                  formatter={(value) => `${value} %`}
                  max={100}
                />
              </Form.Item>
            </Col>
            <Col span={4}>
              <Form.Item
                label="Tỷ lệ tối thiểu (Max)"
                name="per_pro_reorder_max"
                rules={validateRules}
              >
                <InputNumber
                  size="small"
                  style={{ width: '100%' }}
                  formatter={(value) => `${value} %`}
                  max={100}
                />
              </Form.Item>
            </Col>
            <Col span={5}>
              Min:{' '}
              {formatCurrencyVND(
                ((Form.useWatch('per_pro_reorder_min', form) || 0) *
                  (Form.useWatch('per_cap_order_min', form) || 0) *
                  min) /
                  10000
              )}
            </Col>
            <Col span={1}>-</Col>
            <Col span={5}>
              Max:{' '}
              {formatCurrencyVND(
                ((Form.useWatch('per_pro_reorder_max', form) || 0) *
                  (Form.useWatch('per_cap_order_max', form) || 0) *
                  max) /
                  10000
              )}
            </Col>
          </Row>

          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col span={19} offset={5}>
              <Form.Item label="Ghi chú" name="reorder_description">
                <Input style={{ height: '24px' }} />
              </Form.Item>
            </Col>
          </Row>

          <Row
            gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
            justify="start"
            align="bottom"
            style={{ marginTop: '15px' }}
          >
            <Col span={5}>
              {' '}
              <span>Hàng mới</span>
            </Col>
            <Col span={4}>
              <Form.Item
                label="Tỷ lệ tối thiểu (Min)"
                name="per_pro_other_min"
                rules={validateRules}
              >
                <InputNumber
                  size="small"
                  style={{ width: '100%' }}
                  formatter={(value) => `${value} %`}
                  max={100}
                />
              </Form.Item>
            </Col>
            <Col span={4}>
              <Form.Item
                label="Tỷ lệ tối thiểu (Max)"
                name="per_pro_other_max"
                rules={validateRules}
              >
                <InputNumber
                  size="small"
                  style={{ width: '100%' }}
                  formatter={(value) => `${value} %`}
                  max={100}
                />
              </Form.Item>
            </Col>
            <Col span={5}>
              Min:{' '}
              {formatCurrencyVND(
                ((Form.useWatch('per_pro_other_min', form) || 0) *
                  (Form.useWatch('per_cap_order_min', form) || 0) *
                  min) /
                  10000
              )}
            </Col>
            <Col span={1}>-</Col>
            <Col span={5}>
              Max:{' '}
              {formatCurrencyVND(
                ((Form.useWatch('per_pro_other_max', form) || 0) *
                  (Form.useWatch('per_cap_order_max', form) || 0) *
                  max) /
                  10000
              )}
            </Col>
          </Row>

          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col span={19} offset={5}>
              <Form.Item label="Ghi chú" name="other_description">
                <Input style={{ height: '24px' }} />
              </Form.Item>
            </Col>
          </Row>

          <Divider style={{ borderColor: '#E1E3E6' }} dashed />

          <Row gutter={{ xs: 4, sm: 8, md: 16, lg: 24 }} justify="end">
            <Col>
              <Button
                bgColor="bg-white"
                border="border-primary-50"
                color="text-primary-50"
                onClick={onCancel}
              >
                Quay lại
              </Button>
            </Col>

            {IsCapitalDeclare === false ? (
              <Col>
                <Button type="submit">Tạo</Button>
              </Col>
            ) : (
              <Col>
                <Button type="submit">Cập nhật</Button>
              </Col>
            )}
          </Row>
        </Content>
      </Form>
    </Spin>
  );
}
